import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button, Modal } from "@/components/kit";
import SquarePayment from "@/components/SquarePayment";

// Member "Pay dues" flow. The server computes the amount; we only pass the card
// token + a per-attempt order_ref (idempotency). A payment counts as paid only when
// Square confirms it.
export default function PayDues({ amountCents, interval = "yearly", onClose, onPaid }) {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (token, orderRef) => {
    setBusy(true);
    try {
      const r = await api.post("/payments/dues", { interval, source_id: token, order_ref: orderRef });
      setResult(r.data);
      if (r.data.status === "PAID") { toast.success("Payment received — dues paid"); onPaid && onPaid(); }
      else if (r.data.status === "SIMULATED") toast.message("Simulated — Square isn't connected yet");
      else toast.error(r.data.error || `Payment ${r.data.status}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Payment failed");
    } finally { setBusy(false); }
  };

  return (
    <Modal open onClose={onClose} title="Pay membership dues">
      <div data-testid="pay-dues-modal" className="space-y-3">
        <p className="text-[15px] text-ink/70">Amount due: <strong>${(amountCents / 100).toFixed(2)}</strong> / {interval}</p>
        {result?.status === "PAID"
          ? <p className="text-dark-olive font-semibold" data-testid="pay-dues-success">Paid — a receipt has been emailed to you.</p>
          : <SquarePayment amountCents={amountCents} onToken={submit} busy={busy} />}
        {result && result.status !== "PAID" && (
          <p className="text-[13px] text-ink/60" data-testid="pay-dues-status">{result.message || result.error || `Status: ${result.status}`}</p>
        )}
        <Button variant="secondary" onClick={onClose} className="mt-2">Close</Button>
      </div>
    </Modal>
  );
}
